<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="flex items-center w-full my-4">
    <div class="grow border-t border-gray-200"></div>

    <span class="shrink-0 mx-4 text-gray-500 text-sm">
      {{ props.text }}
    </span>

    <div class="grow border-t border-gray-200"></div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  text: String,
})
</script>
